module.exports = __webpack_public_path__ + "media/images/redrock/hero-image-spring-small-ab9afa6a5ee8dcc35e8410d8495592a7.jpg";